import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { MetricWithTrend } from '@/api/metricService';
// import type { MetricWithTrend } from '@packages/database/types';

export const TrendBadge = ({
  metric,
  invertColor = false,
  label = 'vs previous period',
}: {
  metric: MetricWithTrend;
  invertColor?: boolean;
  label?: string;
}) => {
  if (metric.trend === 'flat') {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
        <Minus className="h-3 w-3" />
        No change
      </span>
    );
  }

  const isPositive = metric.trend === 'up';
  const isGood = invertColor ? !isPositive : isPositive;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-xs font-medium',
        isGood
          ? 'text-emerald-600 dark:text-emerald-400'
          : 'text-rose-600 dark:text-rose-400',
      )}
    >
      {isPositive ? (
        <TrendingUp className="h-3 w-3" />
      ) : (
        <TrendingDown className="h-3 w-3" />
      )}
      {Math.abs(metric.deltaPercent)}% {label}
    </span>
  );
};
